module.exports = __webpack_public_path__ + "img/madagascar.4521f38.webp";